import { render, staticRenderFns } from "./StatementBody.vue?vue&type=template&id=27041964&"
import script from "./StatementBody.vue?vue&type=script&lang=ts&"
export * from "./StatementBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports